import React, { Fragment } from 'react';

import useAcknowledgements from './UseAcknowledgements';

import AcknowledgeExistingMemberInfo from './existingMemberInfo/AcknowledgeExistingMemberInfo';
import MemberContactsWrite from '../memberContacts/MemberContactsWrite';
import MemberContactDetail from '../memberContacts/MemberContactDetail';
import MemberContactAddressDetail from '../memberContacts/MemberContactAddressDetail';
import MemberContactPhoneDetail from '../memberContacts/MemberContactPhoneDetail';

import PrimaryButton from '../buttons/PrimaryButton';
import LoadingModal from '../dialogs/LoadingModal';
import PopUpModal from '../dialogs/PopUpModal';
import SecondaryButton from '../buttons/SecondaryButton';
import Input from '../inputs/Input';
import Acknowledgement from './Acknowledgement';

import Constants from '../../utils/Constants';

import global from '../GlobalStyle.module.css';

const Acknowledgements = ({ memberId, addANewFamilyMemberView }) => {
  const {
    personAcknowledgementInfoPageViewState,
    setPersonAcknowledgementInfoPageViewState,
    basePersonState,
    isLoading,
    arrayData,
    isReadyToSign,
    showModal,
    signature,
    signatureErrorMessage,
    message,
    onItemClick,
    onSubmit,
    onSignatureChanged,
    onSigned,
    onModalCanceled,
    onContinueClicked } = useAcknowledgements(memberId, addANewFamilyMemberView);

  return (
    <Fragment>
      {personAcknowledgementInfoPageViewState?.showConfirmContactInfoView === true &&
        <Fragment>
          <div className="row">
            <div className="col-xs-12">
              <AcknowledgeExistingMemberInfo />
            </div>
          </div>
          <PopUpModal
            widthPct={50}
            maxWidth={250}
            title={Constants.LOADING_MSG}
            displayPopUp={basePersonState.isObjLoading} />
        </Fragment>}
      {personAcknowledgementInfoPageViewState?.showChangeContactInfoView === true &&
        <Fragment>
          <div className="row">
            <div className="col-xs-12">
              <MemberContactsWrite
                acknowledgementsView={true}
                personAcknowledgementInfoPageViewState={personAcknowledgementInfoPageViewState}
                setPersonAcknowledgementInfoPageViewState={setPersonAcknowledgementInfoPageViewState} />
            </div>
          </div>
          <div className="row usas-extra-top-margin">
            <div className="col-xs-12 usas-extra-top-margin">
              <PrimaryButton type="button" onClick={(e) => onContinueClicked(e)}>Continue</PrimaryButton>
            </div>
          </div>
        </Fragment>}
      {personAcknowledgementInfoPageViewState?.showChangeContactInfoContactDetailView === true &&
        <div className="row">
          <div className="col-xs-12">
            <MemberContactDetail
              acknowledgementsView={true}
              personAcknowledgementInfoPageViewState={personAcknowledgementInfoPageViewState}
              setPersonAcknowledgementInfoPageViewState={setPersonAcknowledgementInfoPageViewState} />
          </div>
        </div>}
      {personAcknowledgementInfoPageViewState?.showChangeContactInfoContactDetailAddressView === true &&
        <div className="row">
          <div className="col-xs-12">
            <MemberContactAddressDetail
              acknowledgementsView={true}
              personAcknowledgementInfoPageViewState={personAcknowledgementInfoPageViewState}
              setPersonAcknowledgementInfoPageViewState={setPersonAcknowledgementInfoPageViewState} />
          </div>
        </div>}
      {personAcknowledgementInfoPageViewState?.showChangeContactInfoContactDetailPhoneView === true &&
        <div className="row">
          <div className="col-xs-12">
            <MemberContactPhoneDetail
              acknowledgementsView={true}
              personAcknowledgementInfoPageViewState={personAcknowledgementInfoPageViewState}
              setPersonAcknowledgementInfoPageViewState={setPersonAcknowledgementInfoPageViewState} />
          </div>
        </div>}
      {personAcknowledgementInfoPageViewState?.showAcknowledgeSwitchesView === true &&
        <Fragment>
          <div className="row">
            <div className="col-xs-12">
              {isLoading === true
                ? <LoadingModal />
                : arrayData.map((acknowledgement, i) => <Acknowledgement key={i} acknowledgement={acknowledgement} onItemClick={onItemClick} />)}
            </div>
          </div>
          <div className="row">
            <div className="col-xs-12">
              {message && <p className={global.ErrorMessage}>{message}</p>}&nbsp;
            </div>
          </div>
          <div className="row">
            <div className="col-xs-12">
              <PrimaryButton type="button" isDisabled={isReadyToSign !== true} onClick={onSubmit}>Continue</PrimaryButton>
            </div>
          </div>
          <PopUpModal
            widthPct={90}
            maxWidth={720}
            title="Signature"
            displayPopUp={showModal === true}
            onModalCanceled={onModalCanceled}>
            <div className="row">
              <div className="col-xs-12">
                <p>Please type your name below to indicate your signature.</p>
              </div>
            </div>
            <div className="row">
              <div className="col-xs-12">
                <Input
                  error={signatureErrorMessage}
                  label="Signature"
                  message={signatureErrorMessage}
                  name="signature"
                  value={signature}
                  onChange={onSignatureChanged} />
              </div>
            </div>
            <div className="row">
              <div className="col-xs-12 usas-extra-top-margin">
                <PrimaryButton type="button" onClick={onSigned}>Sign the documents</PrimaryButton>&nbsp;&nbsp;
                <SecondaryButton type="button" onClick={onModalCanceled}>Cancel</SecondaryButton>
              </div>
            </div>
          </PopUpModal>
        </Fragment>}
    </Fragment >
  );
};

export default Acknowledgements;